import { ResourceEnum } from "src/constants/constants.ts";

export enum CouponPoolFormTabs {
  General = "general",
  Codes = "codes",
}

/** Action endpoints of CouponPoolController — not part of the resource itself. */
export const couponPoolActionUrl = (
  id: string,
  action: "import" | "codes" | "imports",
) => `/${ResourceEnum.MarketingCouponPool}/${id}/${action}`;

export const voidCouponCodeUrl = (codeId: string) =>
  `/marketing-coupon-code/${codeId}/void`;

export const couponPoolQueryKeys = {
  /**
   * Всё, что вкладка кодов прочитала про пул. Импорт и пометка кода меняют
   * и список кодов, и историю, и счётчики — сбрасывать надо всё вместе.
   */
  all: (poolId: string) => [ResourceEnum.MarketingCouponPool, poolId],
  codes: (
    poolId: string,
    status: string,
    search: string,
    page: number,
    pageSize: number,
  ) => [
    ResourceEnum.MarketingCouponPool,
    poolId,
    "codes",
    status,
    search,
    page,
    pageSize,
  ],
  imports: (poolId: string, page: number, pageSize: number) => [
    ResourceEnum.MarketingCouponPool,
    poolId,
    "imports",
    page,
    pageSize,
  ],
};

/** Предупреждать о сроке действия пула за столько дней (как DEC-014). */
export const EXPIRY_WARNING_DAYS = 14;
